import React from "react";
import { Link } from "react-router-dom";
import UniversePage from "@/pages/UniversePage";
import { GEO_PAGES } from "@/data/geoPages";
import { useJsonLd } from "@/lib/seo";

const Faq = ({ faq }) => (
  <section data-testid="geo-faq" className="px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto py-14">
    <h2 className="font-serif text-3xl">Questions fréquentes</h2>
    <div className="mt-6 divide-y divide-[var(--oz-border)]">
      {faq.map(([q, a]) => (
        <details key={q} className="py-4 group">
          <summary className="cursor-pointer font-semibold list-none flex justify-between gap-4">{q}<span className="text-[var(--oz-gold)] group-open:rotate-45 transition-transform">+</span></summary>
          <p className="mt-2 text-sm text-[var(--oz-muted)] leading-relaxed">{a}</p>
        </details>
      ))}
    </div>
  </section>
);

const Places = ({ current }) => (
  <section data-testid="geo-places" className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pb-16">
    <h2 className="font-serif text-3xl">Nous accompagnons les professionnels partout</h2>
    {["France", "Outre-mer", "Belgique"].map((r) => (
      <div key={r} className="mt-6">
        <h3 className="text-xs uppercase tracking-[0.16em] text-[var(--oz-muted)] font-semibold">{r}</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {GEO_PAGES.filter((g) => g.region === r && g.key !== current).map((g) => (
            <Link key={g.key} to={g.path} data-testid={`geo-link-${g.slug}`} className="rounded-full bg-white border border-[var(--oz-border)] px-4 py-2 text-sm hover:border-[var(--oz-gold)] transition-colors">{g.name}</Link>
          ))}
        </div>
      </div>
    ))}
  </section>
);

export default function GeoPage({ g }) {
  useJsonLd("ld-faq", {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: g.faq.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
  });
  return (
    <div data-testid={`geo-page-${g.slug || "hub"}`}>
      <UniversePage u={g} />
      <Faq faq={g.faq} />
      <Places current={g.key} />
    </div>
  );
}
